export default __webpack_public_path__ + "static/media/10.1adbe4b7.jpg";